<ng-container
  *ngIf="{courseId: courseId$ | async, 
    canViewIssues: canViewIssues$ | async, 
    annotations: annotations$ | async, 
    canSubmitReview: canSubmitReview$ | async, 
    canWithdrawReview: canWithdrawReview$ | async,
    courseInfo: courseInfo$ | async,
    updateDate: courseInfoUpdateDate$ | async,
    loadingStatus: isLoadingDetailsV2$ | async} as vm">
  <div class="instructor-header course flex bg-white py-3 px-6 text-slate-800 border-b border-b-slate-200">
    <ng-container *ngIf="vm.loadingStatus === 'loading'; else loaded">
      <ng-container *ngTemplateOutlet="loadingState"></ng-container>
    </ng-container>
    <ng-template #loaded>
      <div class="flex grow justify-between">
        <div class="left-content flex gap-3 items-center">
          <span (click)="headerAction()" class="bg-slate-700 w-11 h-11 flex items-center justify-center text-slate-300 rounded-sm cursor-pointer lg:hidden">
            <svg-icon [src]="isSidebar ? '@assets/images/icons/x-mark.svg' : '@assets/images/icons/bars-3.svg'" class="ar:rotate-180 h-6 w-6"></svg-icon>
          </span>
          <button (click)="backToDashboard()" class="btn btn-transparent pl-2">
            <svg-icon src="@assets/images/icons/chevron-left.svg" class="rtl:rotate-180 h-4 w-4"></svg-icon>
            <span class="block" i18n>Back</span>
          </button>
          <span class=" w-0.5 h-5 bg-slate-300"></span>
          <div class="flex items-center gap-2 max-sm:flex-col max-sm:items-start max-sm:gap-0">
            <div class="flex gap-3 text-slate-500">
              <div class="font-semibold">{{ vm.courseInfo?.title }}</div>
              <svg-icon src="@assets/images/icons/check-circle.svg" class="h-6 w-6"></svg-icon>
            </div>
            <ng-container *ngIf="!shouldShowCourseSubStatus(vm.courseInfo!)">
              <div class="ar:mr-0 ar:ml-6 p-1" role="alert">
                <span class="status draft" *ngIf="vm.courseInfo?.status === 'draft'" i18n>Draft</span>
                <span class="status in-review" *ngIf="vm.courseInfo?.status === 'in_review'" i18n>In Review</span>
                <span class="status published" *ngIf="vm.courseInfo?.status === 'published'" i18n>Published</span>
                <span class="status rejected" *ngIf="vm.courseInfo?.status === 'rejected'" i18n>Rejected</span>
              </div>
            </ng-container>
            <ng-container *ngIf="shouldShowCourseSubStatus(vm.courseInfo!)">
              <div class="flex gap-2 items-center text-slate-500">
                <div class="status flex-auto p-1" [ngClass]="'published'" role="alert" i18n>
                  Published
                </div>
                <div *ngIf="vm.courseInfo?.status === 'in_review'" i18n>
                  <svg-icon tooltip="Changes under Review" tooltip_position="bottom" src="@assets/images/icons/status-in-review.svg" class="btn-icon h-4 w-4"></svg-icon>
                </div>
                <div *ngIf="vm.courseInfo?.status === 'draft'" i18n>
                  <svg-icon tooltip="Changes in Draft" tooltip_position="bottom" src="@assets/images/icons/hourglass.svg" class="btn-icon h-4 w-4 text-slate-400"></svg-icon>
                </div>
                <div *ngIf="vm.courseInfo?.status === 'rejected'" i18n>
                  <svg-icon tooltip="New changes Rejected" tooltip_position="bottom" src="@assets/images/icons/exclamation-circle-solid.svg" class="btn-icon text-primary-500 h-4 w-4"></svg-icon>
                </div>
                <div *ngIf="vm.courseInfo?.status === 'published'" i18n>
                  <svg-icon tooltip="New changes Published" tooltip_position="bottom" src="@assets/images/icons/check-circle-solid.svg" class="btn-icon h-4 w-4 text-green-500"></svg-icon>
                </div>
              </div>
            </ng-container>
            <span class="text-slate-400 font-normal text-sm italic">Last saved {{vm.updateDate | timeAgo}}</span>
          </div>
        </div>
        <div class="right-content flex">
          <div class="course-actions flex items-center gap-3">
            <button *ngIf="vm.canViewIssues" class="btn btn-sm btn-dark border-slate-700 bg-slate-700"
              (click)="annotationModal.open()">
              <span i18n="course_issues|Button label for issues that the instructor can see after the course review process" class="max-sm:hidden">Issues</span>
              <svg-icon class="btn-icon" src="@assets/images/icons/exclamation-triangle.svg"></svg-icon>
            </button>

            <!-- Menu -->
            <div class="account-menu">
              <app-navigation position="right">
                <ng-container button>
                  <button class="btn btn-sm btn-light">
                    <span i18n="course_preview|Button label that allows the instructor to preview their course" class="max-sm:hidden">Preview</span>
                    <ng-container *ngIf="isLoading">
                      <span [thkLibProcessing]="isLoading" size="sm"></span>
                    </ng-container>
                    <ng-container *ngIf="!isLoading">
                      <svg-icon class="btn-icon" src="@assets/images/icons/chevron-down.svg"></svg-icon>
                    </ng-container>
                  </button>
                </ng-container>
                <ng-container content>
                  <div class="content max-h-[400px] overflow-y-auto border-y border-y-slate-300 rounded-md">
                    <ul class="account-items">
                      <ng-container *ngIf="isLoading">
                        <li class="relative cursor-pointer opacity-5">
                          <a i18n>Learning lab</a>
                        </li>
                      </ng-container>
                      <ng-container *ngIf="!isLoading">
                        <li class="relative cursor-pointer">
                          <a (click)="goToLearningLab(vm.courseId)" i18n>Learning lab</a>
                        </li>
                      </ng-container>
                      <li class="relative cursor-pointer">
                        <a (click)="previewCLP(vm.courseId)" i18n>Course Landing Page <span class="text-slate-400">(Public View)</span></a>
                      </li>
                    </ul>
                  </div>
                </ng-container>
              </app-navigation>
            </div>
            <div class="account-menu">
              @if(preview){
                <ng-container *ngIf="{info: courseInfo$ | async} as course">
                  @if(course.info?.status === 'published'){
                    <button (click)="onEdit(course.info!)" class="btn btn-sm btn-primary">
                      <span i18n="course_edit|Button label that allows the instructor to edit their course" class="max-sm:hidden">Edit</span>
                      <svg-icon class="btn-icon" src="@assets/images/icons/pencil-square.svg"></svg-icon>
                    </button>
                  }@else if(course.info?.status === 'draft' || course.info?.status === 'rejected'){
                    <button (click)="onEdit(course.info!)" class="btn btn-sm btn-primary">
                      <span i18n="course_edit|Button label that allows the instructor to edit their course" class="max-sm:hidden">Resume Editing</span>
                      <svg-icon class="btn-icon" src="@assets/images/icons/pencil-square.svg"></svg-icon>
                    </button>
                  }@else if(course.info?.status === 'in_review'){
                    <button (click)="submitReviewWithdraw()" class="btn btn-sm btn-dark">
                      <span i18n="course_submit_withdraw|Button label that allows the instructor to edit their course" class="max-sm:hidden">Withdraw Submission</span>
                    </button>
                  }
                </ng-container >
              }@else{
                <app-navigation position="right" contentClass="!min-w-[210px]">
                  <ng-container button>
                    <ng-container *ngIf="{details: isSavingDetails$ | async, intended: isSavingIntended$ | async } as saving">
                      <button [disabled]="saving.details === 'loading' || saving.intended === 'loading'" class="btn btn-sm btn-dark">
                        @if(saving.details === 'loading' || saving.intended === 'loading'){
                          <span i18n="course_saving|Button label that allows the instructor to saving their course" class="max-sm:hidden">Saving</span>
                          <div [thkLibProcessing]="true" size="xs" variant="white"></div>
                        }@else{
                        <span i18n="course_save|Button label that allows the instructor to save their course" class="max-sm:hidden">Save</span>
                        <svg-icon class="btn-icon" src="@assets/images/icons/chevron-down.svg"></svg-icon>
                        }
                      </button>
                    </ng-container>
                  </ng-container>
                  <ng-container content>
                    <div class="content max-h-[400px] overflow-y-auto border-y border-y-slate-300 rounded-md">
                      <ul class="account-items">
                        <li class="relative cursor-pointer">
                          <a class="flex items-center gap-2" i18n>
                            <svg-icon class="" src="@assets/images/icons/bookmark.svg"></svg-icon>
                            Save as Draft
                          </a>
                        </li>
                        <li *ngIf="vm.canSubmitReview" (click)="confirmSubmitForReview()" class="relative cursor-pointer">
                          <a class="flex items-center gap-2">
                            <ng-container *ngIf="isSubmittedForReview; else submittedForReview">
                              <span [thkLibProcessing]="isSubmittedForReview" size="sm"></span>
                            </ng-container>
                            <ng-template #submittedForReview>
                              <svg-icon class="" src="@assets/images/icons/paper-airplane.svg"></svg-icon>
                            </ng-template>
                            <span i18n>Submit for Review</span>
                          </a>
                        </li>
                        <li *ngIf="vm.canWithdrawReview" (click)="submitReviewWithdraw()" class="relative cursor-pointer">
                          <a class="flex items-center gap-2">
                            <ng-container *ngIf="isSubmittedForReview; else submittedForReview">
                              <span [thkLibProcessing]="isSubmittedForReview" size="sm"></span>
                            </ng-container>
                            <ng-template #submittedForReview>
                              <svg-icon class="" src="@assets/images/icons/paper-airplane.svg"></svg-icon>
                            </ng-template>
                            <span i18n>Withdraw Submission</span>
                          </a>
                        </li>
                      </ul>
                      <!-- <button *ngIf="vm.canSubmitReview" [disabled]="isSubmittedForReview" class="btn btn-primary px-0" (click)="confirmSubmitForReview()">
                        <span i18n>Submit for Review</span>
                        <ng-container *ngIf="isSubmittedForReview">
                          <ng-container *ngTemplateOutlet="loaderWhite"></ng-container>
                        </ng-container>
                      </button>
                      <button *ngIf="vm.canWithdrawReview" [disabled]="isSubmittedForReview" class="btn btn-primary px-0" (click)="submitReviewWithdraw()">
                        <span i18n>Withdraw Submission</span>
                        <ng-container *ngIf="isSubmittedForReview">
                          <ng-container *ngTemplateOutlet="loaderWhite"></ng-container>
                        </ng-container>
                      </button> -->
                    </div>
                  </ng-container>
                </app-navigation>
              }
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <common-modal #annotationModal i18n-title title="Issues" alignment="right" customClass="sm:w-full sm:max-w-[620px]">
    <ng-container content *ngIf="annotationModal.isOpened">
      <div class="modal-container right scrollBar mr-2 h-screen justify-center overflow-y-scroll p-4 pb-[100px] pr-2">
        <div *ngIf="!vm.annotations?.length" i18n>No issues</div>

        <div *ngFor="let annotation of vm.annotations">
          <div class="my-2 rounded border border-slate-200 p-4">
            <app-common-feedback [annotation]="annotation" (filterEvent)="filterEvent($event)"></app-common-feedback>
          </div>
        </div>
        <span class="absolute w-full h-full top-0 right-0 bg-white bg-opacity-50 flex items-center justify-center" *ngIf="vm.annotations?.length && isSearchingAnnotation" [thkLibProcessing]="true" size="lg"></span>
      </div>
    </ng-container>
  </common-modal>


  <app-common-modal-confirm #submitForReviewConfirmModal
    i18n-title
    i18n-message
    title="Submit for Review"
    message="Are you sure you want to submit this course for review?"
    (confirm)="submitForReview()">
  </app-common-modal-confirm>
  <common-modal #submitForReviewMessagesModal i18n-title title="Why can't I submit?" customClass="text-base sm:w-full sm:max-w-md">
    <ng-container content>
      <div class="validation-messages flex flex-col gap-3 p-6 text-slate-600">
        <ng-container *ngIf="intendedLearnersErrors.length > 0">
          <div>
            <h6 i18n>Intended Learners</h6>
            <ul>
              <ng-container *ngFor="let msg of intendedLearnersErrors">
                <li>{{ msg }}</li>
              </ng-container>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngIf="detailsErrors.length > 0">
          <div>
            <h6 i18n>Details</h6>
            <ul>
              <ng-container *ngFor="let msg of detailsErrors">
                <li>{{ msg }}</li>
              </ng-container>
            </ul>
          </div>
        </ng-container>

        <ng-container *ngIf="curriculumErrors.length > 2">
          <div>
            <h6 i18n>Curriculum</h6>
            <ul>
              <li *ngIf="curriculumError?.lectures" i18n>Have at least {{curriculumError?.min_video_lecture_count}} video lectures</li>
              <li *ngIf="curriculumError?.video_length" i18n>Have at least {{curriculumError?.min_video_length}} minutes of video content</li>
              <!-- <ng-container *ngFor="let msg of curriculumErrors">
                <li>{{ msg }}</li>
              </ng-container> -->
            </ul>
          </div>
        </ng-container>

        <ng-container *ngIf="pricingErrors.length > 0">
          <h6 i18n>Promotions</h6>
          <ul>
            <ng-container *ngFor="let msg of pricingErrors">
              <li>{{ msg }}</li>
            </ng-container>
          </ul>
        </ng-container>
        
        <ng-container *ngIf="annotationErrors.length > 0">
          <h6 i18n>Feedback</h6>
          <ul>
            {{annotationErrors}}
            <ng-container *ngFor="let msg of annotationErrors">
              <li>{{ msg }}</li>
            </ng-container>
          </ul>
        </ng-container>
        <ng-container *ngIf="transcodingErrors.length > 0">
          <h6 i18n>Transcoding</h6>
          <ul>
            <li>{{ transcodingErrors }}</li>
          </ul>
        </ng-container>

        <ng-container *ngIf="blankVideoInfoErrors.length > 0">
          <h6 i18n>Video Info</h6>
          <ul>
            <li>{{ blankVideoInfoErrors }}</li>
          </ul>
        </ng-container>

        <ng-container *ngIf="failedVideoInfoErrors.length > 0">
          <h6 i18n>Failed Video</h6>
          <ul>
            <li>{{ failedVideoInfoErrors }}</li>
          </ul>
        </ng-container>
      </div>
      <div class="flex justify-end gap-2 border-t border-slate-200 px-6 py-4">
        <button class="btn btn-primary" (click)="submitForReviewMessagesModal.close()">
          <span i18n>Close</span>
        </button>
      </div>
    </ng-container>
  </common-modal>

  <ng-template #loadingState>
    <div class="flex grow justify-between items-center">
      <div class="w-1/2 h-6 bg-slate-200 animate-pulse rounded-md"></div>
      <div class="flex gap-3">
        <button class="btn btn-sm btn-light animate-pulse w-24 h-11"></button>
        <button class="btn btn-sm btn-light animate-pulse w-24 h-11"></button>
      </div>
    </div>
  </ng-template>
</ng-container>
